/** Оборачивает URL в `url(...)` для CSS `background-image`. */
export const toCssImageUrl = (imageUrl: string): string => `url(${imageUrl})`;
